export const Relations = {
  IS: "is",
  IS_NOT: "is not",
  LESS_THAN: "is less than",
  GREATER_THAN: "is greater than",
  GREATER_THAN_OR_EQUAL: "is greater than or equal to",
  LESS_THAN_OR_EQUAL: "is less than or equal to",
  BETWEEN: "is between",
  BEFORE: "is before",
  AFTER: "is after",
} as const

export type Relation = (typeof Relations)[keyof typeof Relations]

export type StringRelation = (typeof Relations)[keyof Pick<
  typeof Relations,
  "IS" | "IS_NOT"
>]

export type NumberRelation = (typeof Relations)[keyof Pick<
  typeof Relations,
  | "IS"
  | "IS_NOT"
  | "LESS_THAN"
  | "GREATER_THAN"
  | "GREATER_THAN_OR_EQUAL"
  | "LESS_THAN_OR_EQUAL"
  | "BETWEEN"
>]
